<template>
<div>

    <b-card border-variant="light" v-if="device.status.dhcp_dns.hosts != null">
        <div slot="header">
            <strong>Active DHCP Leases:</strong> Updated {{relativeTime(device.status.dhcp_dns.hosts.ts)}}
            <b-button class="btn btn-primary btn-sm float-right" variant="light" v-if="this.timer===true && device.presence" @click="sendCmd(device.id, 'dhcp_clients', 2000)">
                <b-overlay :show="busy" rounded spinner-small spinner-variant="primary">
                    <i class="fa fa-refresh"></i>
                </b-overlay>
            </b-button>
        </div>

        <b-table small hover :fields="fields" :items="device.status.dhcp_dns.hosts.data" responsive="sm" primary-key="ip">
            <template #cell(index)="data">{{ data.index + 1 }}</template>
        </b-table>

    </b-card>

</div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        device: {
            type: Object,
        },
    },
    created() {
        this.timer = setInterval(this.enableTimer, 1000);
    },
    data() {
        return {
            busy: false,
            timer: false,
            fields: [
                { key: 'index', label: '#' },
                { key: 'host', label: 'Hostname', sortable: true },
                { key: 'mac', label: 'MAC Address', sortable: true },
                { key: 'ip', label: 'IP Address', sortable: true },
                { key: 'exp', label: 'Expires in', sortable: true },
            ]
        }
    },
    methods: {
        enableTimer() {
            this.timer = true;
        },
        relativeTime(value) {
            let localTime = moment.unix(value).local();
            return (value == null) ? '-' : moment(localTime).fromNow()
        },
        makeToast(variant = null, message = null) {
            this.$bvToast.toast(message, {
                // title: `Config Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                solid: true
            });
        },
        sendCmd(id, op, wait) {
            this.busy = true;
            let uri = `/api/devices/${this.device.id}/op?op=${op}`;
            axios.get(uri).then((response) => {
                if (response.data.success === true) {
                    let msg = 'Request sent.' + ' Wait ' + wait / 1000 + ' seconds.';
                    this.makeToast('info', msg);
                    this.stReturn = setTimeout(() => {
                            this.$emit('childgetData_event');
                            this.busy = false
                        },
                        wait);
                } else {
                    this.makeToast('danger', 'Unable to contact device.');
                }
            });
        },
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
}
</script>
